import React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import { CheckCircle, AlertTriangle, XCircle, Info } from 'lucide-react';
export function Toaster() {
  return <SonnerToaster position="top-right" toastOptions={{
    className: 'font-sans',
    style: {
      background: 'white',
      border: '1px solid #E5E7EB',
      color: '#1F2937'
    }
  }} data-id="element-151" />;
}
export const showSuccess = (message: string, description?: string) => {
  toast.success(message, {
    description,
    icon: <CheckCircle className="w-5 h-5 text-green-600" data-id="element-152" />,
    duration: 4000
  });
};
export const showError = (message: string, description?: string) => {
  toast.error(message, {
    description,
    icon: <XCircle className="w-5 h-5 text-red-600" data-id="element-153" />,
    duration: 5000
  });
};
export const showWarning = (message: string, description?: string) => {
  toast.warning(message, {
    description,
    icon: <AlertTriangle className="w-5 h-5 text-amber-500" data-id="element-154" />,
    duration: 4000
  });
};
export const showInfo = (message: string, description?: string) => {
  toast.info(message, {
    description,
    icon: <Info className="w-5 h-5 text-blue-500" data-id="element-155" />,
    duration: 3000
  });
};